//Mostly not available
export const ORIGINAL = "";

//available after resizing - 3 seconds after upload
export const THUMB = "_256x256"; //144p
export const SD = "_720x720"; //480P
export const HD = "_1280x1280"; //720p
export const FULL_HD = "_1920x1920"; //1080p
export const ULTRA_HD = "_3840x3840"; //4k
